import {
  Component,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Tab } from '@modules/tab/interfaces/tab.interface';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TabComponent {
  @Input() labels: string[] = [];
  @Input() selectedIndex: string = '0';
  @Input() width: string = '335px';
  @Output() currentTab: EventEmitter<Tab> = new EventEmitter();

  constructor() {}

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    const position = tabChangeEvent.index;
    const label = tabChangeEvent.tab.textLabel;
    this.currentTab.emit({ position, label });
  }
}
